import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {connect} from 'react-redux';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {closeModal, isLockedValidation} from '../IMEIDeviceRepairSlice';
import Title from '../Shared/Title';
import AlertIcon from './../images/alert.svg';
import {isMobile} from 'react-device-detect';
import {
  dwhPrivateFMIPPageDisplayed,
  dwhPrivateReturnAddressPageButtonClick
} from "app/Components/Block/IMEIDeviceRepairBlock/reports/dwhReports";

const AlertPopUp = (props) => {

  const {selectedAccountOrgName, selectedIMEI} = props.deviceRepairData;
  const selectedHetPay = props.portalState.selectedHetPayId;
  const customerName = props.loginData.userDetails.firstName + ' ' + props.loginData.userDetails.lastName;
  const subscriber = props.loginData.userDetails.contactNumber;

  const isLockedValidation = () => {
    props.isLockedValidation(props.deviceRepairData.selectedIMEI);
    props.closeModal();
  };

  const scenarios = {
    MemberOfDifferentOrg: {
      title: ['Title for MemberOfDifferentOrg scenario'],
      message: 'Message for MemberOfDifferentOrg scenario'
    },
    IsLocked: {
      title: [
        'כדי שנוכל לתאם את השליחות ',
        isMobile ? <br /> : null,
        'יש לכבות ',
        !isMobile ? <br /> : null,
        'את שירות ',
        isMobile ? <br /> : null,
        '״מצא את האייפון שלי״'
      ],
      message: ['שימו לב: לא נוכל לבצע תיקון ',
        isMobile ? <br /> : null,
        'במידה והשירות עדיין פעיל בנייד '],
      secondMessage: [
        'להסבר כיצד לכבות את האפליקציה ',
        isMobile ? <br /> : null,
        '"מצא את האייפון שלי" ',
        <br />,
        '(find my iPhone) ',
        <a href="https://support.apple.com/he-il/HT211149" target="_blank" className="cellcom-color" key="link">לחצו
          כאן</a>
      ],
      onButtonClick: isLockedValidation
    },
    deliveriesFound: {
      title: ['Title for deliveriesFound scenario'],
      message: 'Message for deliveriesFound scenario'
    },
    imeiHelp: {
      title: ['Title for imeiHelp scenario'],
      message: 'Message for imeiHelp scenario'
    },
    WarrInsurInd: props.authentication?.loginData?.userDetails?.isContactPerson ? {
      title: isMobile ? ['למכשיר המקושר למנוי אין',
        <br />,
        'שירות תיקונים'
      ]: ['למכשיר המקושר למנוי אין שירות תיקונים'],
      message:
        props.authentication?.loginData?.userDetails?.IdfIdNumber !== '' ? isMobile ?
          ['יש לפנות למוקד צה"ל',
            <br />,
            'במספר 999*/ 0529990777'
          ] : ['יש לפנות למוקד צה"ל במספר 999*/ 0529990777'] :
          props.authentication?.loginData?.userDetails?.isContactPerson ?
            isMobile ?
    ['אפשר לבחור מכשיר אחר',
      <br />,
      'או לפנות ללאיש הקשר בארגון'] : ['אפשר לבחור מכשיר אחר או לפנות לאיש הקשר בארגון'] : isMobile ?
          ['לברור פרטים נוספים ניתן לפנות',
        <br />,
        'לאיש הקשר בארגון'
      ] : ['לברור פרטים נוספים ניתן לפנות לאיש הקשר בארגון'],
      onButtonClick: props.closeModal
    } : {
      title: isMobile ? ['למכשיר שבחרת',
        <br />,
        'אין שירות תיקונים'
      ] : ['למכשיר שבחרת אין שירות תיקונים'],
      message: isMobile ? ['אפשר לבחור מכשיר אחר',
        <br />,
        'או לפנות לאיש הקשר בארגון'
      ] : ['אפשר לבחור מכשיר אחר או לפנות לאיש הקשר בארגון'],
      onButtonClick: props.closeModal
    },
    GENERAL_ERROR: {
      title: ['התקבלה שגיאה בביצוע הפעולה',
      ],
      message:
        props.authentication?.loginData?.userDetails?.IdfIdNumber !== '' ? isMobile ?
          ['יש לפנות למוקד צה"ל',
            <br />,
            'במספר 999*/ 0529990777'
          ] : ['יש לפנות למוקד צה"ל במספר 999*/ 0529990777'] : isMobile ?
          ['אפשר לפנות לאחראי/ת השירות',
            <br/>,
            ' להמשך טיפול'
          ] : ['אפשר לפנות לאחראי/ת השירות להמשך טיפול'],
      onButtonClick: props.closeModal
    }
  };

  const {title, message, secondMessage = [], onButtonClick} = scenarios[props.deviceRepairData.popUp];

  if (scenarios[props.deviceRepairData.popUp] === scenarios.IsLocked){
    if (props.contentData?.isFromPrivateSelfcare?.value) {
      dwhPrivateFMIPPageDisplayed({selectedHetPay, subscriber, selectedIMEI, customerName, selectedAccountOrgName})
    }
  }

  return (
    <div className="error-popUp">
      <Image src={AlertIcon} alt="alert" className="alert-icon" />
      <Title text={title} />
      <div className={'popup-text'}>
        {message}
      </div>
      <div className={'popup-text'}>
        {secondMessage}
      </div>
        <BtnSubmit text={'הבנתי, תודה'} onclick={() => onButtonClick()} />
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    deviceRepairData: state.iMEIDeviceRepair,
    authentication: state.authentication,
    portalState: state.portalsBlock,
    loginData: state.authentication.loginData
  };
};

const mapDispatchToProps = {closeModal, isLockedValidation};

export default connect(mapStateToProps, mapDispatchToProps)(AlertPopUp);
